import api from "../services";

const panAadharAPI = api.injectEndpoints({
    endpoints: (builder) => ({
        submitPanAadhar: builder.mutation({
            query: ({employeeId, body}) => ({
                url: `/api/employee/partial/update/update/mandatory/documents`,
                method: "POST",
                body: body,params:{employeeId}
            }),
        }),
        panAadharCheck: builder.query({
            query: () => ({
                url: `/api/employee/partial/update/mandatory/documents/status`,
                method: "GET",
            }),
        })
    })
})

export default panAadharAPI;
export const {useSubmitPanAadharMutation, usePanAadharCheckQuery} = panAadharAPI;